module.exports = __webpack_public_path__ + "static/img/send-fail.fa7099b9.svg";